import React from 'react';


export const FastAPI = props => {
    return (
        <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 0C5.375 0 0 5.375 0 12C0 18.627 5.375 24 12 24C18.626 24 24 18.627 24 12C24 5.375 18.627 0 12 0ZM11.376 21.62V14.092H7.19L13.203 2.38V9.908H17.232L11.376 21.62Z"
                fill="#31B07B"/>
        </svg>
    )
};
